"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateField = void 0;
const validateField = (field, value = null, validation) => {
    switch (field.type) {
        case 'email':
            const email = value;
            if (!field.isRequired && (email === null || email.length <= 0)) {
                return true;
            }
            return validation.emailValidationRegex.test(email);
        case 'string':
            if (!field.isRequired) {
                return true;
            }
            const stringValue = value;
            return (stringValue !== null &&
                stringValue.length > 0 &&
                (!field.maxLength || stringValue.length <= field.maxLength) &&
                (!field.minLength || stringValue.length >= field.minLength));
        case 'dateOfBirth':
            const date = value;
            const minDate = field.minValue;
            const maxDate = field.minValue;
            if (!field.isRequired && date === null) {
                return true;
            }
            if (field.isRequired && date === null) {
                return false;
            }
            if (minDate !== null && maxDate !== null) {
                return date < maxDate && date > minDate;
            }
            if (minDate !== null) {
                return date > minDate;
            }
            if (maxDate !== null) {
                return date < maxDate;
            }
            return true;
        case 'address':
            const address = value;
            if (!field.isRequired) {
                return true;
            }
            return address !== null;
        case 'password':
            const password = value;
            return password !== null && validation.passwordValidatorSchema.validate(password);
        case 'phone':
            if (!field.isRequired) {
                return true;
            }
            const phone = value;
            return phone !== null && phone.length > 0;
        case 'radio':
            if (!field.isRequired) {
                return true;
            }
            const radioValue = value;
            return radioValue !== null && radioValue.length > 0;
        case 'boolean':
            if (!field.isRequired) {
                return true;
            }
            const booleanValue = value;
            return booleanValue !== null;
        case 'check-box':
            if (!field.isRequired) {
                return true;
            }
            const checkboxValue = value;
            return checkboxValue.length > 0;
        default:
            return false;
    }
};
exports.validateField = validateField;
//# sourceMappingURL=types.js.map